import _ from 'lodash';
import {
    FETCH_POINTS,
    CLEAN_POINTS,
    DELETE_POINT,
} from './types';
import { request, __ } from '../functions';

export const fetchPoints = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/pickup-points', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_POINTS, payload: data });
    });
};

export const deletePoint = (screen, id) => {
    return dispatch => request(`/pickup-points/remove/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať mapu'));
            return;
        }

        screen.showSnackbar('success', __('Mapa bola zmazaná'));

        dispatch({ type: DELETE_POINT });
    });
};

export const cleanPoints = () => ({ type: CLEAN_POINTS });
